import { render } from "./TextEdit.vue?vue&type=template&id=7f2673fe&scoped=true"
import script from "./TextEdit.vue?vue&type=script&lang=js"
export * from "./TextEdit.vue?vue&type=script&lang=js"

import "./TextEdit.vue?vue&type=style&index=0&id=7f2673fe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2673fe"]])

export default __exports__